module.exports = __webpack_public_path__ + "img/ninguno-de-ellos.f95ffb03.png";